// extracted by mini-css-extract-plugin
export default {"closedRegistrationMessageContainer":"jO19z","closedRegistrationMessage":"FZwep"};